import { ReactNode } from 'react';
import { Heading, HeadingProps } from 'react-aria-components';
import { tv } from 'tailwind-variants';

export interface BlockTitleProps extends HeadingProps {
  children: ReactNode;
  variant?: 'default' | 'v2';
  className?: string;
}

const styles = tv({
  base: 'relative text-xs text-surface-75 text-ellipsis uppercase overflow-hidden font-semibold py-1.5',
  variants: {
    variant: {
      default: 'border-b border-surface-15',
      v2: 'flex gap-2.5 items-center',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

const SectionTitle = ({
  variant = 'default',
  level = 3,
  className,
  children,
}: BlockTitleProps) => {
  return (
    <Heading
      level={level}
      className={styles({
        variant,
        className,
      })}
    >
      {children}
      {variant === 'v2' ? (
        <span className="flex-1 h-[1px] bg-surface-15 -mt-[1px]" />
      ) : null}
    </Heading>
  );
};

export default SectionTitle;
